export default "__VITE_ASSET__jUIuHE9$__"